import React from 'react';
import SectionTitle from './SectionTitle';
import TableReviewLocation from './TableReviewLocation';
import { AiFillCloseCircle } from 'react-icons/ai';
import FormTextField from './FormTextField';
import TouchableOpacity from './TouchableOpacity';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

const TableNumberReview = ({ location }: { location: MapLocation }) => {
  const { setFieldValue, handleChange } = useFormikContext();
  const { t } = useTranslation();
  return (
    <div className="p-2 m-3">
      <TableReviewLocation location={location} />
      <SectionTitle value={t('tableOrder.tableNumber')} />
      <div className="m-3">
        <FormTextField
          name="table"
          type="number"
          label={t('tableOrder.table')}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <TouchableOpacity onClick={() => setFieldValue('table', '')}>
                <AiFillCloseCircle color="silver" size={20} />
              </TouchableOpacity>
            ),
          }}
        />
      </div>
    </div>
  );
};

export default TableNumberReview;
